<template>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      ctrl: this.get_controller("questionnaire"),
    };
  },
  watch: {
    "$route.params.questionnaireId"() {
      if (this.$route.params.questionnaireId != null) {
        this.ctrl.getById(this.$route.params.questionnaireId);
      }
    },
  },
  mounted() {
    if (this.$route.params.questionnaireId != null) {
      this.ctrl.getById(this.$route.params.questionnaireId);
    }
  },
};
</script>